export default __webpack_public_path__ + "static/media/ic-full-test.6a987022.svg";